import * as qplsService from '../../../../services/Qpls/qplsService.js';
import {createDialogActions} from '../../../Dialogs/CommonDialog/commonDialogActions';

export const {
  actionTypes,
  actions,
  api,
  jsxActions,
} = createDialogActions({

  config: {
    getSubmitMethod: () => qplsService.createQplTestField
  },
});


// const config = {
//   getSubmitMethod: () => qplsService.createQplTestField,
// };
//
// export const actionTypes = {
//   ...daHelper.getActionTypes(dialogsNames.CREATE_QPL_TEST_FIELD_DIALOG),
// };
//
// const actions = {
//   ...daHelper.getActions(dialogsNames.CREATE_QPL_TEST_FIELD_DIALOG),
//
// };
//
// export let api = {
//   ...daHelper.getApiActions(actions, config),
// }
//
// export let jsxActions = {
//   ...daHelper.getJsxActions(api),
//
// };
